import EmptyState from './react-ui-empty-state';

export default EmptyState;
